<template>
  <div class="contact-container">
    <!-- 公司信息区域 -->
    <company-info></company-info>
    <!-- 咨询表单模块 -->
    <contact-form></contact-form>
  </div>
</template>

<script>
import ContactForm from '@/views/contact/components/ContactForm'
import CompanyInfo from '@/views/contact/components/CompanyInfo'

export default {
  components:{ContactForm,CompanyInfo},
  data() {
    return {
      
    };
  },
};
</script>

<style lang="less" scoped>

</style>